import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { IdNomOrdreModel } from '../../models/IdNomOrdreModel';
import { CacheService } from '../../services/cache-service';
import { ConfigurationService } from '../../services/configuration.service';
import { GuidService } from '../../services/guid.service';

@Component({
  selector: 'fonction-dropdown',
  templateUrl: './fonction-dropdown.component.html',
  styleUrl: './fonction-dropdown.component.css',
})
export class FonctionDropdownComponent implements OnInit {
  @Input() editMode: boolean = true;
  @Input() showClear: boolean = false;
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  @Input() placeholder: string = '';
  pDropdownStyle: any = {};
  minWidth: string = '84px';

  private _fonctionId: number;
  @Input()
  set fonctionId(value: number) {
    this._fonctionId = value;
    this.selectFonction();
  }
  get fonctionId(): number {
    return this._fonctionId;
  }

  _fonction: IdNomOrdreModel = null;
  @Input()
  set fonction(value: IdNomOrdreModel) {
    this._fonction = value;
  }
  get fonction(): IdNomOrdreModel {
    return this._fonction ? this._fonction : null;
  }

  @Output() fonctionIdChange: EventEmitter<number> = new EventEmitter<number>();
  @Output() fonctionChange: EventEmitter<IdNomOrdreModel> = new EventEmitter<IdNomOrdreModel>();

  public fonctions: IdNomOrdreModel[] = [];
  public guid: string;
  public fonctionsLoaded: boolean = false;

  constructor(
    configurationService: ConfigurationService,
    private guidService: GuidService,
    private cacheService: CacheService,
  ) {
    this.pDropdownStyle = { ...configurationService.pDropdownStyle, 'min-width': this.minWidth };
  }

  ngOnInit() {
    this.guid = this.guidService.newGuid();
    if (!this.fonctionsLoaded) {
      this.loadFonctions();
    } else {
      this.selectFonction();
    }
  }

  selectFonction() {
    if (this.fonctionsLoaded) {
      setTimeout(() => {
        this.fonction = this.fonctions.find(t => this._fonctionId != null && this._fonctionId != undefined && t.Id == this._fonctionId);
      });
    }
  }

  loadFonctions() {
    this.cacheService.getFonctions().subscribe(fonctions => {
      this.fonctions = fonctions;
      this.fonctionsLoaded = true;
      this.selectFonction();
    });
  }

  fonctionChanged() {
    if (this.fonctionsLoaded) {
      if (this._fonctionId != this._fonction?.Id) {
        this._fonctionId = this._fonction?.Id;
        this.fonctionIdChange.emit(this._fonctionId);
        this.fonctionChange.emit(this._fonction);
      }
    }
  }
}
